import { ThunkDispatch } from 'redux-thunk'

import { PaymentMethod } from 'features/checkout/constants'
import { OperationProceedOptions } from 'features/checkout/duck/operations'
import { BREAK_SIGNAL } from 'features/checkout/duck/operations/postProceed/constants'
import { normalizePostProceedBody } from 'features/checkout/duck/operations/postProceed/prepareProceedBody/normalizePostProceedBody'
import { RootState } from 'redux/types'

import {
  PostProceedBody,
  PostProceedBodyType,
  prepareAdyen,
  prepareApplePay,
  prepareBankTransfer,
  prepareCybersource,
  prepareKlarna,
} from './paymentProviders'

interface PrepareProceedBodyArgs {
  state: RootState
  dispatch: ThunkDispatch<RootState, undefined, any>
  selectedPaymentMethod: PaymentMethod
  proceedOptions: OperationProceedOptions
  isPurchaseCoveredByGiftCards: boolean
}

export async function prepareProceedBody({
  state,
  dispatch,
  selectedPaymentMethod,
  proceedOptions: { joinClubParams },
  isPurchaseCoveredByGiftCards,
}: PrepareProceedBodyArgs): Promise<PostProceedBody> {
  let body: PostProceedBodyType

  if (isPurchaseCoveredByGiftCards) {
    body = undefined
  } else {
    switch (selectedPaymentMethod) {
      case PaymentMethod.PayNow:
      case PaymentMethod.PayLater:
      case PaymentMethod.PayInParts:
      case PaymentMethod.PayOverTime:
        body = await prepareKlarna({
          state,
          dispatch,
          selectedPaymentMethod,
        })
        break
      case PaymentMethod.Adyen:
        body = prepareAdyen({ state })
        break
      case PaymentMethod.Cybersource:
        body = prepareCybersource({ state })
        break
      case PaymentMethod.ApplePay:
        body = prepareApplePay({ state })
        break
      case PaymentMethod.BankTransfer:
      case PaymentMethod.Ideal:
        body = prepareBankTransfer({ state, dispatch })
        break
      default:
        body = undefined
    }
  }

  if (body === BREAK_SIGNAL) {
    return BREAK_SIGNAL
  }

  return normalizePostProceedBody({ joinClubParams, state, body })
}
